var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModalTurkTelekom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.875 37.5213L29.6328 33.3249L36.875 29.1962V37.5213ZM36.875 37.5213L29.6328 41.7177L33.2877 43.8159L36.9427 41.7177V37.5213H36.875Z",
    fill: "#CEDC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.875 37.5214L29.6328 41.7177L22.3906 37.5214L29.6328 33.325L36.875 37.5214Z",
    fill: "#0082CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9114 29.1964L58.6016 25V33.3928L65.9114 29.1964Z",
    fill: "#E63323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8789 62.6997V50.1105L44.121 54.3069V37.5213L36.8789 41.7177V37.5213V29.1962L65.9152 45.9141L36.8789 62.6997ZM22.3945 29.1962V37.589L29.6367 33.3926L22.3945 29.1962ZM22.3945 45.9141L29.6367 41.7177L22.3945 37.5213V45.9141Z",
    fill: "#05BEC8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1172 37.5215L36.875 41.7179V50.1107L44.1172 54.3071V37.5215Z",
    fill: "#0082CA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6328 45.9143L36.875 50.1107V41.7179L29.6328 45.9143Z",
    fill: "#002855"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModalTurkTelekom);
export default __webpack_public_path__ + "static/media/logoModalTurkTelekom.9d2fbce6f51bfdb164062efcd14f777d.svg";
export { ForwardRef as ReactComponent };